// extracted by mini-css-extract-plugin
export var divider = "_f7-7";
export var itemsToggle = "_f7-8";
export var mergeModal = "_f7-1";
export var optionCard = "_f7-4";
export var radioGroup = "_f7-6";
export var radioOption = "_f7-0";
export var selected = "_f7-5";
export var shipmentOptions = "_f7-2";
export var tableOptions = "_f7-3";